<div class="apple-register-container" [class.blurred]="showErrorModal">
  <!-- Partner Not Found / Error Modal -->
  <div class="apple-error-modal-overlay" *ngIf="showErrorModal">
    <div class="apple-error-modal">
      <div class="apple-error-icon">
        <i class="material-icons">error_outline</i>
      </div>
      <h2 class="apple-error-title">{{ 'Error' | translate }}</h2>
      <p class="apple-error-message">{{ errorMessage | translate }}</p>
      <div class="apple-error-details" *ngIf="partnerId">
        <span class="apple-error-label">{{ 'PartnerID' | translate }}:</span>
        <span class="apple-error-value">{{ partnerId }}</span>
      </div>
      <a routerLink="/login" class="apple-button primary apple-error-button">
        <i class="material-icons">home</i>
        {{ 'BackToHome' | translate }}
      </a>
    </div>
  </div>

  <!-- Restart Confirmation Modal -->
  <div class="apple-modal-overlay" *ngIf="showRestartConfirm" (click)="cancelRestart()">
    <div class="apple-modal" (click)="$event.stopPropagation()">
      <div class="apple-modal-header">
        <i class="material-icons warning-icon">warning</i>
        <h3>{{ 'ConfirmRestart' | translate }}</h3>
      </div>
      <p class="apple-modal-text">{{ 'RestartWarningMessage' | translate }}</p>
      <div class="apple-modal-buttons">
        <button class="apple-button outline" (click)="cancelRestart()">
          <i class="material-icons">close</i>
          {{ 'Cancel' | translate }}
        </button>
        <button class="apple-button danger" (click)="confirmRestart()">
          <i class="material-icons">restart_alt</i>
          {{ 'StartOver' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Progress Header - Always visible (minimal content when error) -->
  <div class="apple-header">
    <div class="apple-logo-container">
      <img [src]="logoImage" alt="Logo" class="apple-logo">
    </div>
    <h1 class="apple-title" *ngIf="!showErrorModal">{{ getStepTitle() }}</h1>
    <h1 class="apple-title" *ngIf="showErrorModal">{{ 'ExternalPartnerEdit' | translate }}</h1>

    <!-- Tab Navigation (hidden when error modal is shown) -->
    <div class="apple-tab-nav" *ngIf="currentStep > 0 && !showErrorModal">
      <!-- Tab 1: Register (hidden in public mode) -->
      <div class="apple-tab" *ngIf="!isPublicMode"
           [class.active]="currentStep === 1"
           [class.completed]="isStepCompleted(1)"
           [class.disabled]="!isStepEnabled(1) && currentStep !== 1">
        <div class="tab-content">
          <i class="material-icons tab-icon" *ngIf="isStepCompleted(1)">check_circle</i>
          <i class="material-icons tab-icon" *ngIf="!isStepCompleted(1)">person_add</i>
          <span class="tab-label">{{ 'Register' | translate }}</span>
          <span class="tab-label-short">{{ 'Register' | translate }}</span>
        </div>
        <div class="tab-indicator"></div>
      </div>

      <!-- Tab 2: Billing -->
      <div class="apple-tab"
           [class.active]="currentStep === 2"
           [class.completed]="isStepCompleted(2)"
           [class.enabled]="isStepEnabled(2) && currentStep !== 2"
           [class.disabled]="!isStepEnabled(2)"
           (click)="isStepEnabled(2) ? navigateToStep(2) : null">
        <div class="tab-content">
          <i class="material-icons tab-icon" *ngIf="isStepCompleted(2)">check_circle</i>
          <i class="material-icons tab-icon" *ngIf="!isStepCompleted(2)">receipt_long</i>
          <span class="tab-label">{{ 'Billing' | translate }}</span>
          <span class="tab-label-short">{{ 'Billing' | translate }}</span>
        </div>
        <div class="tab-indicator"></div>
      </div>

      <!-- Tab 3: Shipping -->
      <div class="apple-tab"
           [class.active]="currentStep === 3"
           [class.completed]="isStepCompleted(3)"
           [class.enabled]="isStepEnabled(3) && currentStep !== 3"
           [class.disabled]="!isStepEnabled(3)"
           (click)="isStepEnabled(3) ? navigateToStep(3) : null">
        <div class="tab-content">
          <i class="material-icons tab-icon" *ngIf="isStepCompleted(3)">check_circle</i>
          <i class="material-icons tab-icon" *ngIf="!isStepCompleted(3)">local_shipping</i>
          <span class="tab-label">{{ 'Shipping' | translate }}</span>
          <span class="tab-label-short">{{ 'Shipping' | translate }}</span>
        </div>
        <div class="tab-indicator"></div>
      </div>

      <!-- Tab 4: Agents -->
      <div class="apple-tab"
           [class.active]="currentStep === 4"
           [class.completed]="isStepCompleted(4)"
           [class.enabled]="isStepEnabled(4) && currentStep !== 4"
           [class.disabled]="!isStepEnabled(4)"
           (click)="isStepEnabled(4) ? navigateToStep(4) : null">
        <div class="tab-content">
          <i class="material-icons tab-icon" *ngIf="isStepCompleted(4)">check_circle</i>
          <i class="material-icons tab-icon" *ngIf="!isStepCompleted(4)">people</i>
          <span class="tab-label">{{ 'Agents' | translate }}</span>
          <span class="tab-label-short">{{ 'Agents' | translate }}</span>
        </div>
        <div class="tab-indicator"></div>
      </div>
    </div>

    <!-- Existing Partner Badge (hidden when error modal) -->
    <div class="apple-existing-partner-badge" *ngIf="isExistingPartner && currentStep > 1 && !showErrorModal">
      <i class="material-icons">edit</i>
      <span>{{ 'EditingExistingPartner' | translate }}</span>
    </div>

    <!-- Start Over Button (visible on steps 2, 3, 4, hidden when error modal) -->
    <button class="apple-restart-button" *ngIf="currentStep > 1 && !showErrorModal" (click)="showRestartConfirmation()">
      <i class="material-icons">restart_alt</i>
      {{ 'StartOver' | translate }}
    </button>
  </div>

  <!-- Loading Bar -->
  <div class="apple-loading" *ngIf="loading">
    <div class="apple-loading-bar"></div>
  </div>

  <!-- Step 1: Registration / Login -->
  <div class="apple-card animated fadeIn" *ngIf="currentStep === 1">

    <!-- Initial View - Choose Action -->
    <div *ngIf="!isRegistering && !showExistingUserLogin && !ShowMFA">
      <div class="apple-card-header">
        <i class="material-icons apple-icon">account_circle</i>
        <p class="apple-subtitle">{{ 'NoAccountQuestion' | translate }}</p>
      </div>

      <div class="apple-form-group">
        <input type="text" class="apple-input" placeholder="{{ 'Login.Email' | translate }}" [(ngModel)]="loginUserName">
      </div>

      <div class="apple-form-group">
        <input type="password" class="apple-input" placeholder="{{ 'Login.Password' | translate }}" [(ngModel)]="loginPassword">
      </div>

      <div class="apple-checkbox-group">
        <label class="apple-checkbox">
          <input type="checkbox" [(ngModel)]="rememberMe">
          <span class="checkmark"></span>
          {{ 'Login.RememberMe' | translate }}
        </label>
      </div>

      <button class="apple-button primary" [disabled]="loading" (click)="Login();">
        <i class="material-icons">login</i>
        {{ 'IHaveAnCoount' | translate }}
      </button>

      <div class="apple-divider">
        <span>{{ 'Or' | translate }}</span>
      </div>

      <button class="apple-button secondary" [disabled]="loading" (click)="isRegistering = true;">
        <i class="material-icons">person_add</i>
        {{ 'NewAccount' | translate }}
      </button>

      <button class="apple-link-button" [disabled]="loading" (click)="SendRecoverPasswordEmail();">
        {{ 'RecoverPassword' | translate }}
      </button>

      <p class="apple-error" *ngIf="LoginResponse.Status == -1 || LoginResponse.Status == 0;">
        {{ LoginResponse.Message }}
      </p>
    </div>

    <!-- Existing User Login (after attempted registration with existing email) -->
    <div *ngIf="showExistingUserLogin && !ShowMFA">
      <div class="apple-card-header">
        <i class="material-icons apple-icon warning">info</i>
        <p class="apple-subtitle">{{ 'UserAlreadyRegistered' | translate }}</p>
      </div>

      <div class="apple-info-banner">
        <i class="material-icons">person</i>
        <span>{{ 'LoginWithExistingAccount' | translate }}</span>
      </div>

      <div class="apple-form-group">
        <label class="apple-label">{{ 'Login.Email' | translate }}</label>
        <input type="text" class="apple-input" [value]="existingUserEmail" [(ngModel)]="loginUserName" readonly>
      </div>

      <div class="apple-form-group">
        <label class="apple-label">{{ 'Login.Password' | translate }} *</label>
        <input type="password" class="apple-input" placeholder="{{ 'Login.Password' | translate }}" [(ngModel)]="loginPassword" autofocus>
      </div>

      <button class="apple-button primary" [disabled]="loading" (click)="Login();">
        <i class="material-icons">login</i>
        {{ 'Login.LoginButton' | translate }}
      </button>

      <button class="apple-button outline" [disabled]="loading" (click)="showExistingUserLogin = false; isRegistering = true;">
        <i class="material-icons">arrow_back</i>
        {{ 'Login.BackButton' | translate }}
      </button>
    </div>

    <!-- Registration Form -->
    <div *ngIf="isRegistering && !showExistingUserLogin && !ShowMFA">
      <div class="apple-card-header">
        <i class="material-icons apple-icon">person_add</i>
        <p class="apple-subtitle">{{ 'CreateNewAccount' | translate }}</p>
      </div>

      <form [formGroup]="signin" class="apple-form">
        <div class="apple-form-row">
          <div class="apple-form-group">
            <label class="apple-label required">{{ 'Login.Email' | translate }}</label>
            <input type="email" class="apple-input" formControlName="email" placeholder="{{ 'Login.Email' | translate }}">
          </div>

          <div class="apple-form-group">
            <label class="apple-label required">{{ 'Login.Username' | translate }}</label>
            <input type="text" class="apple-input" formControlName="username" placeholder="{{ 'Login.Username' | translate }}">
          </div>
        </div>

        <div class="apple-form-row">
          <div class="apple-form-group">
            <label class="apple-label required">{{ 'Name' | translate }}</label>
            <input type="text" class="apple-input" formControlName="name" placeholder="{{ 'Name' | translate }}">
          </div>

          <div class="apple-form-group">
            <label class="apple-label required">{{ 'Login.Phone' | translate }}</label>
            <input type="tel" class="apple-input" formControlName="phone" placeholder="{{ 'Login.Phone' | translate }}">
          </div>
        </div>

        <div class="apple-form-row">
          <div class="apple-form-group">
            <label class="apple-label required">{{ 'Login.Password' | translate }}</label>
            <div class="apple-input-with-icon">
              <input [type]="hide ? 'password' : 'text'" class="apple-input" formControlName="password" placeholder="{{ 'Login.Password' | translate }}">
              <i class="material-icons input-icon" (click)="hide = !hide">{{ hide ? 'visibility_off' : 'visibility' }}</i>
            </div>
          </div>

          <div class="apple-form-group">
            <label class="apple-label required">{{ 'Login.ConfirmPassword' | translate }}</label>
            <div class="apple-input-with-icon">
              <input [type]="hideCPassword ? 'password' : 'text'" class="apple-input" formControlName="confirmPassword" placeholder="{{ 'Login.ConfirmPassword' | translate }}">
              <i class="material-icons input-icon" (click)="hideCPassword = !hideCPassword">{{ hideCPassword ? 'visibility_off' : 'visibility' }}</i>
            </div>
          </div>
        </div>
      </form>

      <div class="apple-button-group">
        <button class="apple-button outline" [disabled]="loading" (click)="isRegistering = false;">
          <i class="material-icons">arrow_back</i>
          {{ 'Login.BackButton' | translate }}
        </button>

        <button class="apple-button primary" [disabled]="loading || !signin.valid" (click)="RegisterNewUser();">
          <i class="material-icons">check</i>
          {{ 'Login.RegisterNowTitle' | translate }}
        </button>
      </div>
    </div>

    <!-- MFA Verification -->
    <div *ngIf="ShowMFA">
      <div class="apple-card-header">
        <i class="material-icons apple-icon">security</i>
        <p class="apple-subtitle">{{ 'EnterToken' | translate }}</p>
      </div>

      <div class="apple-form-group">
        <label class="apple-label">{{ 'MFAToken' | translate }}</label>
        <input type="text" class="apple-input mfa-input" [(ngModel)]="MFAToken" placeholder="000000" maxlength="6">
      </div>

      <button class="apple-button primary" [disabled]="loading" (click)="VerifyMFAToken();">
        <i class="material-icons">verified</i>
        {{ 'VerifyToken' | translate }}
      </button>

      <button class="apple-button outline" [disabled]="loading" (click)="ShowMFA = false;">
        <i class="material-icons">arrow_back</i>
        {{ 'Login.BackButton' | translate }}
      </button>
    </div>
  </div>

  <!-- Step 2: Billing Information -->
  <div class="apple-card animated fadeIn" *ngIf="currentStep === 2">
    <div class="apple-card-header">
      <i class="material-icons apple-icon">receipt</i>
      <p class="apple-subtitle">{{ 'GeneralInformation' | translate }}</p>
    </div>

    <div class="apple-form-section">
      <h3 class="apple-section-title">
        <i class="material-icons">business</i>
        {{ 'GeneralInformation' | translate }}
      </h3>

      <div class="apple-form-row">
        <div class="apple-form-group">
          <label class="apple-label required">{{ 'CompanyName' | translate }}</label>
          <input type="text" class="apple-input" [class.mandatory-empty]="!Partner.Name?.trim()" [(ngModel)]="Partner.Name" placeholder="{{ 'CompanyName' | translate }}">
        </div>

        <div class="apple-form-group">
          <label class="apple-label required">{{ 'VAT' | translate }}</label>
          <input type="text" class="apple-input" [class.mandatory-empty]="!Partner.VAT?.trim()" [(ngModel)]="Partner.VAT" placeholder="{{ 'VAT' | translate }}">
        </div>
      </div>

      <div class="apple-form-row">
        <div class="apple-form-group">
          <label class="apple-label">{{ 'UPN' | translate }}</label>
          <input type="text" class="apple-input" [(ngModel)]="Partner.UPN" placeholder="{{ 'UPN' | translate }}">
        </div>

        <div class="apple-form-group">
          <label class="apple-label">{{ 'COCRegNumber' | translate }}</label>
          <input type="text" class="apple-input" [(ngModel)]="Partner.COCRegNumber" placeholder="{{ 'COCRegNumber' | translate }}">
        </div>
      </div>
    </div>

    <div class="apple-form-section">
      <h3 class="apple-section-title">
        <i class="material-icons">location_on</i>
        {{ 'BillingAddress' | translate }}
      </h3>

      <div class="apple-form-row">
        <div class="apple-form-group">
          <label class="apple-label required">{{ 'Country' | translate }}</label>
          <div class="apple-dropdown-container">
            <div class="apple-dropdown-overlay" *ngIf="showBillingCountryDropdown" (click)="showBillingCountryDropdown = false"></div>
            <div class="apple-dropdown-bar" [class.open]="showBillingCountryDropdown" [class.mandatory-empty]="!Partner.BillingAddress?.Country?.ID" (click)="showBillingCountryDropdown = !showBillingCountryDropdown">
              <span [class.placeholder]="!Partner.BillingAddress?.Country">
                {{ Partner.BillingAddress?.Country?.Name || ('SelectCountry' | translate) }}
              </span>
              <i class="material-icons">expand_more</i>
            </div>
            <div class="apple-dropdown-results" *ngIf="showBillingCountryDropdown">
              <div class="apple-dropdown-option" *ngFor="let c of Countries"
                   [class.selected]="Partner.BillingAddress?.Country?.ID === c.ID"
                   (click)="Partner.BillingAddress.Country = c; showBillingCountryDropdown = false;">
                {{ c.Name }}
                <i class="material-icons" *ngIf="Partner.BillingAddress?.Country?.ID === c.ID">check</i>
              </div>
            </div>
          </div>
        </div>

        <div class="apple-form-group">
          <label class="apple-label required">{{ 'StateProvince' | translate }}</label>
          <input type="text" class="apple-input" [class.mandatory-empty]="!Partner.BillingAddress?.StateProvince?.trim()" [(ngModel)]="Partner.BillingAddress.StateProvince" placeholder="{{ 'StateProvince' | translate }}">
        </div>
      </div>

      <div class="apple-form-row">
        <div class="apple-form-group">
          <label class="apple-label required">{{ 'City' | translate }}</label>
          <input type="text" class="apple-input" [class.mandatory-empty]="!Partner.BillingAddress?.City?.trim()" [(ngModel)]="Partner.BillingAddress.City" placeholder="{{ 'City' | translate }}">
        </div>

        <div class="apple-form-group">
          <label class="apple-label required">{{ 'ZipCode' | translate }}</label>
          <input type="text" class="apple-input" [class.mandatory-empty]="!Partner.BillingAddress?.ZipCode?.trim()" [(ngModel)]="Partner.BillingAddress.ZipCode" placeholder="{{ 'ZipCode' | translate }}">
        </div>
      </div>

      <div class="apple-form-group full-width">
        <label class="apple-label required">{{ 'Address' | translate }}</label>
        <input type="text" class="apple-input" [class.mandatory-empty]="!Partner.BillingAddress?.AddressLine?.trim()" [(ngModel)]="Partner.BillingAddress.AddressLine" placeholder="{{ 'Address' | translate }}">
      </div>
    </div>

    <div class="apple-form-section">
      <h3 class="apple-section-title">
        <i class="material-icons">account_balance</i>
        {{ 'Partners.PartnerWindow.Bank' | translate }}
      </h3>

      <div class="apple-form-row">
        <div class="apple-form-group">
          <label class="apple-label">{{ 'Partners.PartnerWindow.Bank' | translate }}</label>
          <div class="apple-bank-row">
            <div class="apple-dropdown-container">
              <div class="apple-dropdown-overlay" *ngIf="showBankDropdown" (click)="showBankDropdown = false"></div>
              <div class="apple-dropdown-bar" [class.open]="showBankDropdown" (click)="showBankDropdown = !showBankDropdown">
                <span [class.placeholder]="!Partner.Bank?.Name">
                  {{ Partner.Bank?.Name || ('SelectBank' | translate) }}
                </span>
                <i class="material-icons">expand_more</i>
              </div>
              <div class="apple-dropdown-results" *ngIf="showBankDropdown">
                <div class="apple-dropdown-option" *ngFor="let b of Banks"
                     [class.selected]="Partner.Bank?.ID === b.ID"
                     (click)="Partner.Bank = b; showBankDropdown = false;">
                  {{ b.Name }}
                  <i class="material-icons" *ngIf="Partner.Bank?.ID === b.ID">check</i>
                </div>
              </div>
            </div>
            <button class="apple-add-bank-btn" type="button" (click)="toggleAddBankForm()" *ngIf="!showAddBankForm">
              <i class="material-icons">add</i>
            </button>
          </div>
        </div>

        <div class="apple-form-group">
          <label class="apple-label">{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}</label>
          <input type="text" class="apple-input" [(ngModel)]="Partner.Bank.BankAccount" placeholder="{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}">
        </div>

        <!-- Add New Bank Form - Full Width -->
        <div class="apple-add-bank-form" *ngIf="showAddBankForm">
          <div class="apple-add-bank-input-row">
            <input type="text" class="apple-input" [(ngModel)]="newBankName"
                   placeholder="{{ 'EnterBankName' | translate }}" [disabled]="addingBank">
            <input type="text" class="apple-input apple-input-swift" [(ngModel)]="newBankSwift"
                   placeholder="{{ 'Swift' | translate }}" [disabled]="addingBank">
            <button class="apple-add-bank-save" type="button" [disabled]="addingBank || !newBankName || !newBankSwift" (click)="addNewBank()">
              <i class="material-icons">check</i>
            </button>
            <button class="apple-add-bank-cancel" type="button" [disabled]="addingBank" (click)="cancelAddBank()">
              <i class="material-icons">close</i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="apple-form-section">
      <h3 class="apple-section-title">
        <i class="material-icons">person</i>
        {{ 'Partners.PartnerWindow.ContactInfo' | translate }}
      </h3>

      <div class="apple-form-row">
        <div class="apple-form-group">
          <label class="apple-label">{{ 'Partners.PartnerWindow.Name' | translate }}</label>
          <input type="text" class="apple-input" [(ngModel)]="Partner.ContactInfo.Name" placeholder="{{ 'Partners.PartnerWindow.Name' | translate }}">
        </div>

        <div class="apple-form-group">
          <label class="apple-label">{{ 'Email' | translate }}</label>
          <input type="email" class="apple-input" [(ngModel)]="Partner.ContactInfo.Email" placeholder="{{ 'Email' | translate }}">
        </div>
      </div>

      <div class="apple-form-group">
        <label class="apple-label">{{ 'Login.Phone' | translate }}</label>
        <input type="tel" class="apple-input" [(ngModel)]="Partner.ContactInfo.Phone" placeholder="{{ 'Login.Phone' | translate }}">
      </div>
    </div>

    <div class="apple-button-group">
      <button class="apple-button primary" [disabled]="loading" (click)="proceedToStepC();">
        {{ 'Continue' | translate }}
        <i class="material-icons">arrow_forward</i>
      </button>
    </div>
  </div>

  <!-- Step 3: Shipping Information -->
  <div class="apple-card animated fadeIn" *ngIf="currentStep === 3">
    <div class="apple-card-header">
      <i class="material-icons apple-icon">local_shipping</i>
      <p class="apple-subtitle">{{ 'ShippingAddresses' | translate }}</p>
    </div>

    <!-- Shipping Addresses List Section -->
    <div class="apple-form-section">
      <div class="apple-section-header-row">
        <h3 class="apple-section-title">
          <i class="material-icons">list_alt</i>
          {{ 'YourShippingAddresses' | translate }}
        </h3>
        <button class="apple-button small primary" (click)="openNewShippingAddressPopup()">
          <i class="material-icons">add</i>
          {{ 'AddNew' | translate }}
        </button>
      </div>

      <!-- Empty State -->
      <div class="apple-empty-state" *ngIf="!Partner.ShippingAddresses || Partner.ShippingAddresses.length === 0">
        <i class="material-icons">location_off</i>
        <p>{{ 'NoShippingAddressesYet' | translate }}</p>
        <span>{{ 'ClickAddNewToCreateFirstAddress' | translate }}</span>
      </div>

      <!-- Address Cards Grid -->
      <div class="shipping-address-grid" *ngIf="Partner.ShippingAddresses?.length > 0">
        <div class="shipping-address-card"
             *ngFor="let address of Partner.ShippingAddresses; let i = index"
             [class.selected]="selectedShippingAddressIndex === i"
             (click)="selectShippingAddress(address, i)">
          <div class="address-card-header">
            <i class="material-icons">location_on</i>
            <span class="address-country">{{ address.Country?.Name }}</span>
            <i class="material-icons check-icon" *ngIf="selectedShippingAddressIndex === i">check_circle</i>
          </div>
          <div class="address-card-body">
            <div class="address-line">{{ address.AddressLine }}</div>
            <div class="address-city-zip">{{ address.City }}, {{ address.ZipCode }}</div>
            <div class="address-state">{{ address.State }}</div>
          </div>
          <div class="address-card-contact">
            <div class="contact-person"><i class="material-icons">person</i> {{ address.ContactPerson }}</div>
            <div class="contact-company"><i class="material-icons">business</i> {{ address.ContactCompany }}</div>
          </div>
          <div class="address-card-actions">
            <button class="apple-button small outline" (click)="openEditShippingAddressPopup(address, i); $event.stopPropagation()">
              <i class="material-icons">edit</i>
              {{ 'Edit' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="apple-button-group">
      <button class="apple-button outline" [disabled]="loading" (click)="goBackToStep(2);">
        <i class="material-icons">arrow_back</i>
        {{ 'Login.BackButton' | translate }}
      </button>

      <button class="apple-button primary" [disabled]="loading || !Partner.ShippingAddresses?.length" (click)="proceedToStepD();">
        {{ 'Continue' | translate }}
        <i class="material-icons">arrow_forward</i>
      </button>
    </div>
  </div>

  <!-- Step 4: Agents Information -->
  <div class="apple-card animated fadeIn" *ngIf="currentStep === 4">
    <div class="apple-card-header">
      <i class="material-icons apple-icon">people</i>
      <p class="apple-subtitle">{{ 'AgentsInfo' | translate }}</p>
    </div>

    <!-- Agents List -->
    <div class="apple-agents-list" *ngIf="PartnerAgents?.length > 0">
      <div class="apple-agent-item clickable" *ngFor="let agent of PartnerAgents; let i = index"
           [class.editing]="isEditingAgent && editingAgentIndex === i"
           (click)="editAgent(agent, i)">
        <div class="agent-avatar">
          <i class="material-icons">person</i>
        </div>
        <div class="agent-info">
          <span class="agent-name">{{ agent.Name }}
            <span class="ExtPartnerPhasesBadge" *ngIf="agent.OrderPhases?.length > 0">{{agent.OrderPhases.length}}</span>
          </span>
          <span class="agent-email">{{ agent.Email }}</span>
          <span class="agent-phone">{{ agent.Phone }}</span>
          <span class="agent-department" *ngIf="agent.Department?.Name">{{ agent.Department.Name }}</span>
        </div>
        <div class="agent-edit-hint">
          <i class="material-icons">edit</i>
        </div>
      </div>
    </div>

    <div class="apple-empty-state" *ngIf="PartnerAgents?.length === 0 && !showAgentForm">
      <i class="material-icons">people_outline</i>
      <p>{{ 'NoAgentsYet' | translate }}</p>
    </div>

    <!-- Add Agent Button -->
    <button class="apple-button secondary add-agent-btn" (click)="showAddAgentForm();">
      <i class="material-icons">person_add</i>
      {{ 'AddNewAgent' | translate }}
    </button>

    <div class="apple-button-group final-buttons">
      <button class="apple-button outline" [disabled]="loading" (click)="goBackToStep(3);">
        <i class="material-icons">arrow_back</i>
        {{ 'Login.BackButton' | translate }}
      </button>

      <button class="apple-button primary complete-btn" [disabled]="loading" (click)="completeRegistration();">
        <i class="material-icons">check_circle</i>
        {{ 'Complete' | translate }}
      </button>
    </div>
  </div>

  <!-- Completion Confirmation Modal -->
  <div class="apple-completion-overlay" *ngIf="showCompletionModal">
    <div class="apple-completion-modal">
      <div class="apple-completion-icon-wrapper">
        <i class="material-icons apple-completion-icon">check_circle</i>
      </div>
      <h2 class="apple-completion-title">{{ 'PartnerDataConfirmationTitle' | translate }}</h2>
      <p class="apple-completion-message">{{ 'PartnerDataConfirmationMessage' | translate }}</p>
      <p class="apple-completion-note">{{ 'PartnerDataConfirmationNote' | translate }}</p>
      <button class="apple-button primary apple-completion-button" (click)="closeCompletionAndWindow()">
        <i class="material-icons">done_all</i>
        {{ 'Understood' | translate }}
      </button>
    </div>
  </div>

  <!-- Footer -->
  <div class="apple-footer">
    <p class="apple-copyright">{{ 'CopyRightRow' | translate }}</p>
  </div>

  <!-- Agent Form Popup (outside of cards for full-page overlay) -->
  <div class="apple-modal-overlay" *ngIf="showAgentForm" (click)="cancelAgentForm()"></div>
  <div class="apple-agent-modal" *ngIf="showAgentForm && PartnerAgent">
    <div class="apple-modal-header">
      <h3>
        <i class="material-icons">{{ isEditingAgent ? 'edit' : 'person_add' }}</i>
        {{ (isEditingAgent ? 'EditAgent' : 'AddNewAgent') | translate }}
      </h3>
      <button class="apple-modal-close" (click)="cancelAgentForm()">
        <i class="material-icons">close</i>
      </button>
    </div>

    <div class="apple-modal-body">
      <div class="apple-form-row">
        <div class="apple-form-group">
          <label class="apple-label required">{{ 'Name' | translate }}</label>
          <input type="text" class="apple-input" [class.mandatory-empty]="!PartnerAgent?.Name?.trim()" [(ngModel)]="PartnerAgent.Name" placeholder="{{ 'Name' | translate }}">
        </div>

        <div class="apple-form-group">
          <label class="apple-label required">{{ 'Phone' | translate }}</label>
          <input type="tel" class="apple-input" [class.mandatory-empty]="!PartnerAgent?.Phone?.trim()" [(ngModel)]="PartnerAgent.Phone" placeholder="{{ 'Phone' | translate }}">
        </div>
      </div>

      <div class="apple-form-row">
        <div class="apple-form-group">
          <label class="apple-label required">{{ 'Email' | translate }}</label>
          <input type="email" class="apple-input" [class.mandatory-empty]="!PartnerAgent?.Email?.trim()" [(ngModel)]="PartnerAgent.Email" placeholder="{{ 'Email' | translate }}">
        </div>

        <div class="apple-form-group" *ngIf="Departments?.length > 0">
          <label class="apple-label">{{ 'Department' | translate }}</label>
          <div class="apple-dropdown-container">
            <div class="apple-dropdown-overlay" *ngIf="showDepartmentDropdown" (click)="showDepartmentDropdown = false"></div>
            <div class="apple-dropdown-bar" [class.open]="showDepartmentDropdown" (click)="showDepartmentDropdown = !showDepartmentDropdown">
              <span [class.placeholder]="!PartnerAgent.Department">
                {{ PartnerAgent.Department?.Name || ('SelectDepartment' | translate) }}
              </span>
              <i class="material-icons">expand_more</i>
            </div>
            <div class="apple-dropdown-results" *ngIf="showDepartmentDropdown">
              <div class="apple-dropdown-option" *ngFor="let d of Departments"
                   [class.selected]="PartnerAgent.Department?.ID === d.ID"
                   (click)="PartnerAgent.Department = d; showDepartmentDropdown = false;">
                {{ d.Name }}
                <i class="material-icons" *ngIf="PartnerAgent.Department?.ID === d.ID">check</i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="apple-form-group" *ngIf="ShippingAddresses?.length > 0">
        <label class="apple-label">{{ 'ShippingAddresses' | translate }}</label>
        <div class="apple-dropdown-container">
          <div class="apple-dropdown-overlay" *ngIf="showAgentShippingDropdown" (click)="showAgentShippingDropdown = false"></div>
          <div class="apple-dropdown-bar" [class.open]="showAgentShippingDropdown" (click)="showAgentShippingDropdown = !showAgentShippingDropdown">
            <span [class.placeholder]="!PartnerAgent.AllocatedShippingAddress">
              {{ PartnerAgent.AllocatedShippingAddress ? (PartnerAgent.AllocatedShippingAddress.Country?.Name + ' ' + PartnerAgent.AllocatedShippingAddress.City) : ('SelectAddress' | translate) }}
            </span>
            <i class="material-icons">expand_more</i>
          </div>
          <div class="apple-dropdown-results" *ngIf="showAgentShippingDropdown">
            <div class="apple-dropdown-option" *ngFor="let a of ShippingAddresses"
                 [class.selected]="PartnerAgent.AllocatedShippingAddress?.ID === a.ID"
                 (click)="PartnerAgent.AllocatedShippingAddress = a; showAgentShippingDropdown = false;">
              {{ a.Country?.Name }} {{ a.City }} {{ a.AddressLine }}
              <i class="material-icons" *ngIf="PartnerAgent.AllocatedShippingAddress?.ID === a.ID">check</i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Select Notification Phases Button (only for saved agents) -->
    <div style="padding: 0 20px 12px 20px;" *ngIf="PartnerAgent?.ID > 0">
      <button class="DefaultPhasesBtn" (click)="openDefaultPhasesPopup(PartnerAgent);"
              [class.has-phases]="PartnerAgent?.OrderPhases?.length > 0">
        <i class="material-icons">tune</i>
        <span>{{ 'SelectNotificationPhases' | translate }}</span>
        <span class="DefaultPhasesBtnCount" *ngIf="PartnerAgent?.OrderPhases?.length > 0">{{PartnerAgent.OrderPhases.length}}</span>
        <i class="material-icons" style="margin-left:auto;font-size:18px;color:#999;">expand_more</i>
      </button>
    </div>

    <div class="apple-modal-footer">
      <button class="apple-button outline" (click)="cancelAgentForm();">
        <i class="material-icons">close</i>
        {{ 'Cancel' | translate }}
      </button>

      <button class="apple-button primary" [disabled]="loading" (click)="AddUpdatePartnerAgent();">
        <i class="material-icons">save</i>
        {{ 'SaveButton' | translate }}
      </button>
    </div>
  </div>

  <!-- Shipping Address Popup (Add/Edit) -->
  <div class="shipping-popup-overlay" *ngIf="showShippingAddressPopup && currentStep === 3">
    <div class="shipping-popup">
      <div class="shipping-popup-title">
        <i class="material-icons">{{ isNewShippingAddress ? 'add_location' : 'edit_location' }}</i>
        <span *ngIf="isNewShippingAddress">{{ 'AddNewShippingAddress' | translate }}</span>
        <span *ngIf="!isNewShippingAddress">{{ 'EditShippingAddress' | translate }}</span>
      </div>
      <div class="shipping-popup-body">
        <!-- Address Details -->
        <div class="apple-form-section">
          <h3 class="apple-section-title">
            <i class="material-icons">edit_location</i>
            {{ 'AddressDetails' | translate }}
          </h3>

          <div class="apple-form-row">
            <div class="apple-form-group">
              <label class="apple-label required">{{ 'Country' | translate }}</label>
              <div class="apple-dropdown-container">
                <div class="apple-dropdown-overlay" *ngIf="showPopupShippingCountryDropdown" (click)="closePopupShippingCountryDropdown()"></div>
                <div class="apple-dropdown-bar" [class.open]="showPopupShippingCountryDropdown" [class.mandatory-empty]="!editingShippingAddress?.Country?.ID" (click)="showPopupShippingCountryDropdown = !showPopupShippingCountryDropdown">
                  <span [class.placeholder]="!editingShippingAddress?.Country?.Name">
                    {{ editingShippingAddress?.Country?.Name || ('SelectCountry' | translate) }}
                  </span>
                  <i class="material-icons">expand_more</i>
                </div>
                <div class="apple-dropdown-results searchable" *ngIf="showPopupShippingCountryDropdown">
                  <div class="apple-dropdown-search">
                    <i class="material-icons">search</i>
                    <input type="text" [(ngModel)]="popupShippingCountrySearchTerm"
                           placeholder="{{ 'SearchCountry' | translate }}"
                           (click)="$event.stopPropagation()" autofocus>
                    <i class="material-icons clear" *ngIf="popupShippingCountrySearchTerm" (click)="popupShippingCountrySearchTerm = ''; $event.stopPropagation()">close</i>
                  </div>
                  <div class="apple-dropdown-options-container">
                    <div class="apple-dropdown-option" *ngFor="let c of getFilteredPopupShippingCountries()"
                         [class.selected]="editingShippingAddress?.Country?.ID === c.ID"
                         (click)="selectPopupShippingCountry(c)">
                      {{ c.Name }}
                      <i class="material-icons" *ngIf="editingShippingAddress?.Country?.ID === c.ID">check</i>
                    </div>
                    <div class="apple-dropdown-no-results" *ngIf="getFilteredPopupShippingCountries().length === 0">
                      {{ 'NoResultsFound' | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="apple-form-group">
              <label class="apple-label required">{{ 'StateProvince' | translate }}</label>
              <input type="text" class="apple-input" [class.mandatory-empty]="!editingShippingAddress?.State?.trim()" [(ngModel)]="editingShippingAddress.State" placeholder="{{ 'StateProvince' | translate }}">
            </div>
          </div>

          <div class="apple-form-row">
            <div class="apple-form-group">
              <label class="apple-label required">{{ 'Partners.PartnerWindow.City' | translate }}</label>
              <input type="text" class="apple-input" [class.mandatory-empty]="!editingShippingAddress?.City?.trim()" [(ngModel)]="editingShippingAddress.City" placeholder="{{ 'Partners.PartnerWindow.City' | translate }}">
            </div>

            <div class="apple-form-group">
              <label class="apple-label required">{{ 'ZipCode' | translate }}</label>
              <input type="text" class="apple-input" [class.mandatory-empty]="!editingShippingAddress?.ZipCode?.trim()" [(ngModel)]="editingShippingAddress.ZipCode" placeholder="{{ 'ZipCode' | translate }}">
            </div>
          </div>

          <div class="apple-form-group full-width">
            <label class="apple-label required">{{ 'Partners.PartnerWindow.AddressLine' | translate }}</label>
            <input type="text" class="apple-input" [class.mandatory-empty]="!editingShippingAddress?.AddressLine?.trim()" [(ngModel)]="editingShippingAddress.AddressLine" placeholder="{{ 'Partners.PartnerWindow.AddressLine' | translate }}">
          </div>
        </div>

        <!-- Contact Information -->
        <div class="apple-form-section">
          <h3 class="apple-section-title">
            <i class="material-icons">person</i>
            {{ 'Partners.PartnerWindow.ContactInfo' | translate }}
          </h3>

          <div class="apple-form-row">
            <div class="apple-form-group">
              <label class="apple-label required">{{ 'Partners.PartnerWindow.ContactInfo' | translate }}</label>
              <input type="text" class="apple-input" [class.mandatory-empty]="!editingShippingAddress?.ContactPerson?.trim()" [(ngModel)]="editingShippingAddress.ContactPerson" placeholder="{{ 'Partners.PartnerWindow.ContactInfo' | translate }}">
            </div>

            <div class="apple-form-group">
              <label class="apple-label required">{{ 'Company' | translate }}</label>
              <input type="text" class="apple-input" [class.mandatory-empty]="!editingShippingAddress?.ContactCompany?.trim()" [(ngModel)]="editingShippingAddress.ContactCompany" placeholder="{{ 'Company' | translate }}">
            </div>
          </div>

          <div class="apple-form-row">
            <div class="apple-form-group">
              <label class="apple-label required">{{ 'Email' | translate }}</label>
              <input type="email" class="apple-input" [class.mandatory-empty]="!editingShippingAddress?.Email?.trim()" [(ngModel)]="editingShippingAddress.Email" placeholder="{{ 'Email' | translate }}">
            </div>

            <div class="apple-form-group">
              <label class="apple-label required">{{ 'Login.Phone' | translate }}</label>
              <input type="tel" class="apple-input" [class.mandatory-empty]="!editingShippingAddress?.Phone?.trim()" [(ngModel)]="editingShippingAddress.Phone" placeholder="{{ 'Login.Phone' | translate }}">
            </div>
          </div>
        </div>
      </div>
      <div class="shipping-popup-actions">
        <button class="apple-button outline" [disabled]="savingShippingAddress" (click)="closeShippingAddressPopup()">
          <i class="material-icons">close</i>
          {{ 'Cancel' | translate }}
        </button>
        <button class="apple-button primary" [disabled]="savingShippingAddress" (click)="saveShippingAddressFromPopup()">
          <i class="material-icons" *ngIf="!savingShippingAddress">{{ isNewShippingAddress ? 'add' : 'save' }}</i>
          <i class="material-icons rotating" *ngIf="savingShippingAddress">sync</i>
          <span *ngIf="isNewShippingAddress">{{ 'AddAddress' | translate }}</span>
          <span *ngIf="!isNewShippingAddress">{{ 'SaveChanges' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Default Agent Phases Popup -->
<div class="ExtPartnerPhasesPopupOverlay" *ngIf="showDefaultPhasesPopup" (click)="closeDefaultPhasesPopup();">
  <div class="ExtPartnerPhasesPopup" (click)="$event.stopPropagation();">
    <div class="ExtPartnerPhasesPopupHeader">
      <div class="ExtPartnerPhasesPopupTitle">
        <i class="material-icons">tune</i>
        {{ 'SelectNotificationPhases' | translate }} — {{selectedDefaultPhaseAgent?.Name}}
      </div>
      <button class="ExtPartnerPhasesPopupClose" (click)="closeDefaultPhasesPopup();">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ExtPartnerPhasesPopupBody">
      <p class="ExtPartnerPhasesExplanation">
        <i class="material-icons" style="font-size:14px;vertical-align:middle;margin-right:4px;color:#4a7bb8;">info_outline</i>
        {{ 'NotificationPhasesExplanation' | translate }}
      </p>
      <div class="DefaultPhaseItem" *ngFor="let phase of defaultPhasesMasterData"
           [class.selected]="isDefaultPhaseSelected(phase)"
           (click)="toggleDefaultPhase(phase)">
        <div class="DefaultPhaseItemRow">
          <i class="material-icons DefaultPhaseCheckIcon"
             [style.color]="isDefaultPhaseSelected(phase) ? '#007aff' : '#ccc'">
            {{ isDefaultPhaseSelected(phase) ? 'check_circle' : 'radio_button_unchecked' }}
          </i>
          <span class="DefaultPhaseName">{{phase.Name}}</span>
        </div>
        <p class="DefaultPhaseDescription">{{phase.Description}}</p>
      </div>
    </div>
    <div class="ExtPartnerPhasesPopupFooter">
      <button class="ExtPartnerPhasesSaveBtn" (click)="saveDefaultPhases();" [disabled]="savingDefaultPhases">
        <i class="material-icons">save</i>
        {{'SaveButton' | translate}}
      </button>
    </div>
  </div>
</div>